import styled from '@emotion/styled';

export const Button = styled.button`
  display: block;
  border: none;
  margin-left: auto;
  padding: 0;
  background-color: transparent;
  width: 32px;
  height: 32px;
`;
